import { createReducer, on } from '@ngrx/store';
import { notificationApiActions } from '../actions/notifications.action';
import { Notification } from '../../core/services/notifications.service';

export interface NotificationsState {
    notifications?: any;
    notificationsAuthorizations?: any;
    unreadCount?: number;
    notificationDetail?: Notification;
}

export const initialState: NotificationsState = {};

export const notificationsReducer = createReducer(
    initialState,
    on(
        notificationApiActions.notificationsRequest,
        (state): NotificationsState => ({ ...state, notifications: { isLoading: true } })
    ),
    on(
        notificationApiActions.notificationsSuccess,
        (state, notifications): NotificationsState => ({
            ...state,
            notifications: { isLoading: false, notifications },
            // La página 1 trae las más nuevas: sirve para el contador del badge sin otra llamada
            ...(notifications.notifications?.currentPage === 1
                ? { unreadCount: (notifications.notifications.data ?? []).filter(n => !n.read).length }
                : {}),
        })
    ),
    on(
        notificationApiActions.notificationsFailure,
        (state, error): NotificationsState => ({ ...state, notifications: { isLoading: false, error } })
    ),
    on(
        notificationApiActions.notificationsAuthorizationsRequest,
        (state): NotificationsState => ({ ...state, notificationsAuthorizations: { isLoading: true } })
    ),
    on(
        notificationApiActions.notificationsAuthorizationsSuccess,
        (state, notifications): NotificationsState => ({ ...state, notificationsAuthorizations: { isLoading: false, notifications } })
    ),
    on(
        notificationApiActions.notificationsAuthorizationsFailure,
        (state, error): NotificationsState => ({ ...state, notificationsAuthorizations: { isLoading: false, error } })
    ),
    on(
        notificationApiActions.unreadCountSuccess,
        (state, { unreadCount }): NotificationsState => ({ ...state, unreadCount })
    ),
    on(
        notificationApiActions.notificationDetailRequest,
        (state): NotificationsState => ({ ...state, notificationDetail: undefined })
    ),
    on(
        notificationApiActions.notificationDetailSuccess,
        (state, { notification }): NotificationsState => ({ ...state, notificationDetail: notification })
    ),
    on(
        notificationApiActions.notificationReadSuccess,
        (state): NotificationsState => ({ ...state, unreadCount: Math.max(0, (state.unreadCount ?? 0) - 1) })
    ),
);




export const notificationFeatureKey = 'notifications';
